import React from 'react';

type ManagedFolderClosedIconProps = {
	label: string;
	size?: 'small' | 'medium';
	color?: string;
	testId?: string;
};

/**
 * Custom icon for a managed (synced) closed folder.
 * Renders a folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */
const ManagedFolderClosedIcon = ({
	label,
	size = 'medium',
	color,
	testId,
}: ManagedFolderClosedIconProps): React.JSX.Element => {
	const dimensions = size === 'small' ? 16 : 24;
	const fillColor = color || 'currentColor';
	return (
		<svg
			data-testid={testId}
			width={dimensions}
			height={dimensions}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role={label ? 'img' : 'presentation'}
			aria-label={label || undefined}
			aria-hidden={!label}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.31055 2.75H13C14.1046 2.75 15 3.64543 15 4.75V10H13.5V7.5H2.5V13C2.5 13.2761 2.72386 13.5 3 13.5H10V15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H6.56055L8.31055 2.75ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V6H13.5V4.75C13.5 4.47386 13.2761 4.25 13 4.25H7.68945L5.93945 2.5H3Z"
				fill={fillColor}
			/>
			<path
				d="M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z"
				fill={fillColor}
			/>
		</svg>
	);
};

export { ManagedFolderClosedIcon };
